<h1 ev-dialog-title>{{ languageService.languageJSON.TabbedInfoDialog_PrivacyPolicy }}</h1>

<div ev-dialog-content #privacyScrollbar class="scrollable" data-testid="privacy-container">
  <div class="privacy-content">
    <app-modal-option-panel>
      <span panel-title>{{ languageService.languageJSON.TabbedInfoDialog_PrivacyPolicy }}</span>
      <div class="privacy-policy">
    <p><strong>Preamble</strong></p>

    <p>GPS Tuner Systems Kft, Vérmezö út 4, 1012 Budapest. Hungary</p>

    <p>As part of the Service, we offer users reliable navigation with individual navigation profiles, detailed route
        planning and many other extras on their own computer, smartphone or tablet.</p>

    <p>When using the Service, we process personal data of the user. By personal data we mean all information relating
        to an
        identified or identifiable natural person.</p>

    <p>Because the protection of your privacy is important to us, we would like to use the following information to
        inform
        you which personal data we process when you use the app and how we handle this data. In addition, we will inform
        you
        about the legal basis for the processing of your data.</p>

    <p>You can access this data protection declaration at any time under the “Account - Info - Shield sign - Privacy
        Policy”
        from the Service.</p>

    <h3>1. Information on the processing of your data</h3>

    <p>Certain information is already processed automatically when you use the Service. We have listed the specific
        personal
        data that will be processed for you below:</p>

    <h3>1.1. Information collected during download</h3>

    <p>When you download the Smartphone App, certain necessary information will be transmitted to the App Store you
        select
        (e.g. Google Play or Apple App Store), including but not limited to your email address, customer number of your
        account, time of download, payment information, and unique device identification number. The processing of this
        data
        is carried out exclusively by the respective App Store and is beyond our control.</p>

    <h3>1.2. Information collected when an account is created</h3>

    <p>When you create an account the following information of the user will be requested:</p>

    <ul>
        <li>First Name</li>
        <li>Last Name</li>
        <li>Country</li>
        <li>Phone Number</li>

        <li>Data about the car (Brand, Model, Type, Fast Charge Limit, Battery/Range Adjustment, Charger Types, Custom Name,
            Trip Recording)</li>

        <li>Settings (Toll Roads, Ferries, Highways, Language, Favorite/Disabled Charging Stations, Prefer/Avoid
            Charging Operators, Home Address, Work Address, Voice Guidance, Theme, Map Show Pois, Distance, Temperature, Speed, Pressure)
        </li>
    </ul>

    <p>This information is stored in the end device and is anonymized and transferred to us; (1) to provide you with the
        service and related features; (2) to improve the features and performance of the app.</p>

    <p>This data processing is legitimated because (1) you consent to the processing by providing the data in accordance
        with Art. 6 para. 1 lit. a) GDPR or (2) we have a legitimate interest in being able to offer a service that is
        in
        line with the market and interest-oriented and outweighs your rights and interests in the protection of the data
        to
        be processed within the meaning of Art. 6 para. 1 lit. f) GDPR.</p>

    <h3>1.3. Information that is collected automatically</h3>

    <p>As part of your use of the app, we automatically collect certain data required for the use of the app. This
        includes
    </p>

    <ul>
        <li>IP address and time of access</li>
        <li>Requesting server (so-called user agent)</li>
        <li>ID of the end device (so-called UUID)</li>
        <li>Type, version of the operating system, and language of the end device.</li>
    </ul>

    <p>This data is automatically transmitted to us and stored by us in accordance with Section 4 (1) in order to
        provide
        you with the service and the associated features; (2) to improve the features of the Service; and (3) to prevent
        and
        eliminate misuse and malfunctions.</p>

    <p>This data processing is legitimate because (1) the processing is necessary for the fulfilment of the contract
        between
        you as the data subject and us pursuant to Art. 6 para. 1 lit. b) GDPR for the use of the Service, or (2) we
        have a
        legitimate interest in ensuring the operability and error-free operation of the Service and can offer a service
        that
        is in line with the market and interest-oriented and outweighs your rights and interests in the protection of
        the
        data to be processed pursuant to Art. 6 Para. 1 lit. f) GDPR.</p>

    <h3>1.4. Use of the Service</h3>

    <p>When using the Service, we might collect the following data in anonymous form, which is required for the use of
        the
        app or the features offered. These are:</p>

    <ul>
        <li>Car ID</li>
        <li>Latitude</li>
        <li>Longitude</li>
        <li>Speed</li>
        <li>Heading</li>
        <li>State of Charge (estimated)</li>
        <li>Timestamp</li>
    </ul>

    <p>This data is automatically transmitted to us and stored by us in anonymous form in accordance with Section 4 (1)
        in
        order to provide you with the service and the associated features; (2) to improve the services and features of
        the
        app; and (3) to prevent and eliminate misuse and malfunctions. An assignment to a specific user is not possible
        for
        us.</p>

    <p>The processing and use of this usage data is done to provide the service. This data processing is legitimated by
        the
        fact that the processing is necessary for the fulfilment of the contract between you or the respective customer
        and
        us pursuant to Art. 6 Para. 1 lit. b) GDPR.</p>

    <p>In accordance with Art. 13 GDPR, we must inform the respective customer about this data processing and the
        transfer
        to us at the time of collection.</p>

    <h3>2. Transmission and transfer of data</h3>

    <p>The data to be processed will only be transmitted without your express prior consent in addition to the cases
        explicitly mentioned in this data protection declaration if it is legally permissible or necessary.</p>

    <h3>2.1. The information that you provide during the registration will be shared within our group of undertakings
        for
        internal
        administrative purposes, including joint customer support as necessary</h3>

    <p>Any transmission of personal data is legitimate by the fact that we have a legitimate interest in disclosing the
        data
        for administrative purposes within our group of undertakings and that your rights and interests in the
        protection of
        the data to be processed within the meaning of Art. 6 para. 1 lit. f) GDPR do not predominate.</p>

    <h3>3. Third Party Accounts</h3>

    <p>EVNavigation.com allows you to sign up and log in to the Services using accounts you create with third-party
        products
        and services, such as Facebook, Google, or Apple (collectively, „Third-Party Accounts”).</p>

    <p>If you access the Services with Third-Party Accounts we will collect information that you have agreed to make
        available such as your name, email address, profile information, and preferences.</p>

    <p>This information is collected by the Third-Party Account provider and is provided to EVNavigation.com under their
        privacy policies.</p>

    <p>You can generally control the information that we receive from these sources using the privacy controls in your
        Third-Party Account.</p>

    <h3>4. Data transfers to third countries</h3>

    <p>A transfer to states outside the European Economic Area does not take place.</p>

    <h3>5. Period of data storage</h3>

    <p>We erase or anonymize the data to be processed as soon as they are no longer required for the purposes for which
        we
        have collected or used them in accordance with the above paragraphs. As a rule, we store the data to be
        processed
        for the duration of the usage or contractual relationship via the app plus a period of 30 days during which we
        store
        backup copies after erasure, provided that this data is no longer needed for criminal prosecution or to secure,
        pursue or enforce legal claims.</p>

    <p>Specific details in this data protection declaration or legal requirements for the storage and erasure of
        personal
        data, in particular those which we have to store for tax reasons, remain unaffected.</p>

    <h3>6. Rights of the data subject</h3>

    <p>Contact: <a href="mailto:support@evnavigation.com" target="_blank">support&#64;evnavigation.com</a></p>

    <h3>6.1. Right of access</h3>

    <p>You have the right to obtain from us at any time upon request information on the personal data processed by us
        concerning you in the scope of Art. 15 GDPR. For this purpose, you may submit an application by post or by
        e-mail to
        the address given above.</p>

    <h3>6.2. Right to rectification</h3>

    <p>You have the right to ask us to correct your personal data immediately if it is inaccurate. If you wish to do so,
        please contact us at the above address.</p>

    <h3>6.3. Right to erasure</h3>

    <p>You have the right, under the conditions described in Art. 17 GDPR, to request us to erase your personal data. In
        particular, these conditions provide for a right of erasure if the personal data are no longer necessary for the
        purposes for which they were collected or otherwise processed, or in cases of unlawful processing, the existence
        of
        an objection or the existence of a duty to erase under Union law or the law of the Member State to which we are
        subject. For the period of data storage, please see Section 5 of this data protection declaration. In order to
        assert your right to erasure, please contact us at the above address.</p>

    <p>You have the rights to delete your own account from the EVNavigation.com website or within the Smartphone
        applications. Please, note that some data will be retained for legitimate reasons such as security, fraud
        prevention, regulatory compliance.</p>

    <h3>6.4. Right to restriction processing</h3>

    <p>You have the right to demand from us the restriction of processing in accordance with Art. 18 GDPR. This right
        exists
        in particular if the correctness of the personal data is disputed between the user and us, for the duration
        which
        the verification of the correctness requires, as well as in the event that the user demands limited processing
        instead of erasure in the case of an existing right to erasure; furthermore in the event that the data is no
        longer
        necessary for the purposes pursued by us, but the user requires it for the assertion, exercise or defense of
        legal
        claims, and if the successful exercise of an objection between us and the user is still disputed. To exercise
        your
        right to restrict processing, please contact us at the above address.</p>

    <h3>6.5. Right to data portability</h3>

    <p>You have the right to receive from us the personal data concerning you which you have provided to us in a
        structured,
        common, machine-readable format in accordance with Art. 20 GDPR. To exercise your right to data portability,
        please
        contact us at the above address.</p>

    <h3>7. Right to object</h3>

    <p>You have the right, for reasons arising from your particular situation, to object at any time to the processing
        of
        personal data concerning you, which is carried out, among other things, on the basis of Art. 6 para. 1 lit. e)
        or f)
        GDPR, pursuant to Art. 21 GDPR. We will terminate the processing of the data to be processed unless we can prove
        compelling grounds for processing worthy of protection which outweigh your interests, rights and freedoms, or if
        the
        processing serves the assertion, exercise or defense of legal claims.</p>

    <h3>8. Right to complain</h3>

    <p>You also have the right to address complaints to the competent supervisory authority.</p>

    <h3>9. Changes to this Data Protection Declaration</h3>

    <p>We always keep this data protection declaration up to date. Therefore, we reserve the right to change it from
        time to
        time and to update changes in the collection, processing or use of your data.</p>

    <h3>10. Cookies Policy</h3>

    <h3>10.1 What Are Cookies?</h3>

    <p>As is common practice with almost all professional websites, this site uses cookies, which are tiny files that
        are
        downloaded to your computer to improve your experience. This page describes what information they gather, how we
        use
        it, and why we sometimes need to store these cookies. We will also share how you can prevent these cookies from
        being stored, however, this may downgrade or "break" certain elements of the site's functionality.</p>

    <p>For more general information on cookies, see the Wikipedia article on HTTP Cookies.</p>

    <h3>10.2 How We Use Cookies</h3>

    <p>We use cookies for a variety of reasons detailed below. Unfortunately, in most cases, there are no industry
        standard
        options for disabling cookies without completely disabling the functionality and features they add to this site.
        If
        you are not sure whether you need them in a service you use, it is recommended that you leave on all cookies.
    </p>

    <h3>10.3 Disabling Cookies</h3>

    <p>You can prevent the use of cookies by adjusting the settings in your browser (see your browser's "Help" option on
        how
        to do this). Be aware that disabling cookies will affect the functionality of this site, along with many other
        websites you visit. Disabling cookies usually also results in disabling certain functionalities and features of
        the
        website. Therefore, it is recommended that you do not disable cookies.</p>

    <h3>10.4 The Cookies We Set</h3>

    <ul>
        <li>Site preferences cookies.</li>

        <li>In order to provide you with a great experience on this site, we provide the functionality to set your
            preferences on
            how this site runs while you use it. In order to remember your preferences, we need to set cookies so that
            this
            information can be called whenever you interact with a page that is affected by your preferences.</li>
    </ul>

    <h3>10.5 Third Party Cookies</h3>

    <p>In some special cases, we also use cookies provided by trusted third parties. The following section details which
        third party cookies you might encounter through this site:</p>

    <ul>
        <li>This site uses Google Analytics which is one of the most widespread and trusted analytics solution on the
            web for
            helping us understand how you use the site and ways that we can improve your experience. These cookies may
            track
            things such as how much time you spend on the site and the pages you visit, so that we can continue
            producing
            engaging content.</li>

        <li>For more information on Google Analytics cookies, see the official Google Analytics page.</li>

        <li>We use the Google Places API. Google Places API may collect and process information about your actual
            location.
            We do
            not combine the information collected through the use of Google Analytics with personally identifiable
            information.
            Google's ability to use and share information collected by the Google Places API is governed by the 
            <a href="https://policies.google.com/privacy" target="_blank">Google Privacy Policy</a>.</li>
    </ul>

    <h3>11. Contacting Us</h3>

    <p>If there are any questions regarding this privacy policy or you would like to report something in relation to
        your
        personal data you may contact us using the information below.</p>

    <p>GPS Tuner Systems Kft</p>
    <p>H-1012 Budapest, Vérmezõ street 4.</p>
    <p><a href="https://www.gpstuner.com" target="_blank">www.gpstuner.com</a></p>
    <p><a href="mailto:support@evnavigation.com" target="_blank">support&#64;evnavigation.com</a></p>

    <p>Last update: 20.01.2026</p>

    <p class="bottom-link"><a (click)="openEuDataPolicy()" data-testid="privacy-eu-data-act-link">{{ languageService.languageJSON.TabbedInfoDialog_EUDataActPolicy }}</a></p>
</div>
    </app-modal-option-panel>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" name="ok_button" mat-button (click)="dialogRef?.close()" data-testid="privacy-close-btn">
    {{ languageService.languageJSON.Global_Close }}
  </button>
</div>